import { TimesheetAction } from "../actions/timesheetsPage";
import TYPES from "../types/timesheets";

interface State {
  isLoading: boolean;
  list: MockTimesheets[];
  success: boolean;
}

const initialState: State = {
  success: false,
  isLoading: false,
  list: [],
};

const reducer: (state: State, action: TimesheetAction) => State = (
  state = initialState,
  action
) => {
  switch (action.type) {
    case TYPES.START:
      return {
        ...state,
        isLoading: true,
      };
    case TYPES.SUCCESS:
      return {
        isLoading: false,
        success: true,
        list: action.payload,
      };
    case TYPES.FAIL:
      return {
        isLoading: false,
        success: false,
        list: [],
      };
    default:
      return state;
  }
};

export default reducer;
